import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Paragraph from './Paragraph';
import ShareButtons from './ShareButtons';
import Section from './Section';

export default function SubscribeShareSection({ shareUrl }) {
  const { t } = useTranslation();

  return (
    <Section
      content={(
        <>
          <Paragraph
            bold
            textAlign="center"
          >
            {t('thx_socials_p')}
          </Paragraph>
          <Paragraph textAlign="center">
            <a href="https://t.me/votebelarus2020" className="telegram social" rel="noreferrer" target="_blank">
              <FontAwesomeIcon icon={['fab', 'telegram-plane']} color="white" />
            </a>
            <a href="https://invite.viber.com/?g2=AQBZ9eVwoKmWt0vfMTIOw26q7lxbECkQmqGc7Cu1sG7XqSPkWMU8H2Rd%2F%2BF%2BiKcL" className="viber social" rel="noreferrer" target="_blank">
              <FontAwesomeIcon icon={['fab', 'viber']} color="white" />
            </a>
          </Paragraph>
          <Paragraph
            bold
            textAlign="center"
          >
            {t('thx_sharing_p')}
          </Paragraph>
          <ShareButtons
            align="center"
            share={['vk', 'facebook', 'odnoklassniki', 'twitter']}
            url={shareUrl}
          />
        </>
      )}
    />
  );
}

SubscribeShareSection.propTypes = {
  shareUrl: PropTypes.string.isRequired,
};
